import {Injectable} from '@angular/core';
import {authStore} from './auth.store';
import {setProps} from '@ngneat/elf';

@Injectable({providedIn: 'root'})
export class AuthManager {
  public setToken(token: string) {
    authStore.update(setProps({token}));
  }

  public setRefreshToken(token: string) {
    authStore.update(setProps({refreshToken: token}));
  }

  public reset() {
    authStore.reset();
  }
}
